document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-icon-row-slider]')
  if (sliders.length) {
    let swipers = []
    sliders.forEach((slider, i) => {
      const buildSlider = () => {
        swipers[i] = new Swiper(slider, {
          slidesPerView: 'auto',
          pagination: {
            el: slider.parentElement.querySelector('.swiper-pagination'),
            type: 'bullets',
            clickable: true
          },
          breakpoints: {
            320: {
              spaceBetween: 40,            
              // slidesOffsetBefore: 100,
              slidesOffsetAfter: 100,
              centeredSlides: true,
              centerInsufficientSlides: true
            },
            768: {
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
            1000: {
              centeredSlides: false,
              spaceBetween: 50,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
            1400: {
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              spaceBetween: 0
            }
          }
        })
      }
      const startSliders = () => {
        if (window.matchMedia('(max-width: 900px)').matches) {
          if (swipers.length) return
          buildSlider()
        } else {
          if (swipers[i]) {
            swipers[i].destroy(true, true)
            swipers = []
          }
        }
      }
      startSliders()
      window.addEventListener('resize', () => {
        startSliders()
      })
    })
  }
})